export default __webpack_public_path__ + "static/icon-grid-background-5cc36448aeefa2c8dc3a194a222a1a01.svg";